module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "properties"
  }, _vm._l((_vm.showFields), function(row) {
    return _c('div', {
      staticClass: "row"
    }, [(!row.component) ? [_c('div', {
      staticClass: "col-12 name"
    }, [_vm._v(_vm._s(row.name))]), _c('div', {
      staticClass: "col-12 value"
    }, [(["campaign.clone_of", "campaign.clone_for"].indexOf(row.slug) !== -1) ? _c('b-btn', {
      attrs: {
        "variant": "link",
        "to": {
          name: 'campaign',
          params: {
            code: row.value
          }
        }
      }
    }, [_vm._v(_vm._s(row.value))]) : _vm._e(), (row.slug === "facebook_pixel") ? _c('facebook-pixel', {
      attrs: {
        "pixel": row.value
      }
    }) : [_vm._v(_vm._s(row.value))]], 2)] : [_c('div', {
      staticClass: "col-sm-12"
    }, [_c(row.component, {
      tag: "component",
      attrs: {
        "readonly": !_vm.permissions.includes(row.permission)
      }
    })], 1)]], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66442b9f"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rabbit/campaign-summary/CampaignSummary.vue
// module id = 2057
// module chunks = 1